import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Session } from "types/generated";

const SessionsTableIpAddressCell = ({
  item: session,
  ...cellProps
}: TableSimpleCellProps<Pick<Session, "ipAddress">>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{session.ipAddress}</TableCellText>
    </TableSimpleCell>
  );
};

export default SessionsTableIpAddressCell;
